// extracted by mini-css-extract-plugin
export var container = "_ib-0";
export var outlet = "_ib-1";
export var outletEnter = "_ib-2";
export var outletEnterActive = "_ib-3";
export var outletExit = "_ib-4";
export var outletExitActive = "_ib-5";